import { createAction } from 'typesafe-actions'

export const setProject = createAction('project->SET')<number>()
export const clearProject = createAction('project->CLEAR')<number>()
